import { apiService } from '../../..'
import { VerificationMethod } from '../../verify/types'
import {
  AuthCheckCodeRequest,
  AuthCheckCodeResponse,
  AuthLoginRequest,
  AuthLoginResponse,
  authResetCodeSendRequest,
  AuthResetRequest,
  CashAuth,
  CashAuthQuery,
  Check2FACodeRequest,
  TwoFactorChallengeRequest,
} from '../types'

const baseURL = '/portal/consumers/auth'

export const authService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    cash: build.query<CashAuth, CashAuthQuery>({
      query: (body) => {
        return {
          url: `${baseURL}/cash`,
          method: 'POST',
          data: body,
        }
      },
      providesTags: (_, __, arg) => [{ type: 'CashAuth', id: arg.token }],
    }),
    authLogoutEndpoint: build.mutation<void, void>({
      query: () => {
        return {
          url: `${baseURL}/logout`,
          method: 'POST',
        }
      },
    }),
    authLogin: build.mutation<AuthLoginResponse, AuthLoginRequest>({
      query: (req) => {
        const { username, password, 'remember-me': rememberMe } = req
        const formData = new URLSearchParams({
          username,
          password,
          'remember-me': String(rememberMe),
        })
        return {
          url: `${baseURL}/login`,
          method: 'POST',
          data: formData,
        }
      },
    }),
    authResetCode: build.mutation<void, authResetCodeSendRequest>({
      query: (req) => {
        return {
          url: `${baseURL}/reset/code`,
          method: 'POST',
          data: req,
        }
      },
    }),
    authCheckCode: build.mutation<AuthCheckCodeResponse, AuthCheckCodeRequest>({
      query: (req) => {
        return {
          url: `${baseURL}/reset/check-code`,
          method: 'POST',
          data: req,
        }
      },
    }),
    authReset: build.mutation<void, AuthResetRequest>({
      query: (req) => {
        return {
          url: `${baseURL}/reset`,
          method: 'POST',
          data: req,
        }
      },
    }),
    authCheckChallenge: build.mutation<void, TwoFactorChallengeRequest>({
      query: (req) => {
        return {
          url: `${baseURL}/reset/check-two-factor-challenges`,
          method: 'POST',
          data: req,
        }
      },
    }),
    check2faCode: build.mutation<void, Check2FACodeRequest>({
      query: (req) => {
        return {
          url: `${baseURL}/2fa/check-code`,
          method: 'POST',
          data: req,
        }
      },
    }),
    get2faCode: build.mutation<void, { sendBy: VerificationMethod }>({
      query: (req) => {
        return {
          url: `${baseURL}/2fa/code`,
          method: 'POST',
          data: req,
        }
      },
    }),
  }),
})
